__turbopack_context__.v({
  "about": "-1X4Kq_about",
  "arrow": "-1X4Kq_arrow",
  "breadcrumb": "-1X4Kq_breadcrumb",
  "container-img": "-1X4Kq_container-img",
  "container-video": "-1X4Kq_container-video",
  "description": "-1X4Kq_description",
  "detail": "-1X4Kq_detail",
  "image": "-1X4Kq_image",
  "label": "-1X4Kq_label",
  "link": "-1X4Kq_link",
  "motto": "-1X4Kq_motto",
  "quote": "-1X4Kq_quote",
  "title": "-1X4Kq_title",
});
